import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './i18n';
import { ThemeProvider } from './context/ThemeContext';
import { trackPageView } from './config/analytics';

// Layout Components
import MainHeader from './components/MainHeader';
import MainFooter from './components/MainFooter';

// Pages
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';

// Google Analytics tracking component for React Router
const GoogleAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
};

// Layout wrapper component
const Layout = ({ children }) => (
  <>
    <MainHeader />
    {children}
    <MainFooter />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <div className="App">
            <BrowserRouter>
              <GoogleAnalyticsTracker />
              <Routes>
                <Route path="/" element={<Layout><HomePage /></Layout>} />
                <Route path="/bikes/:bikeSlug" element={<Layout><ProductPage /></Layout>} />
              </Routes>
            </BrowserRouter>
          </div>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;